import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import {
  initMetaPixel,
  trackAppStoreClick,
  trackPageView,
  trackPlayStoreClick,
} from '../utils/meta-pixel';

// OneLink AppsFlyer : gère l'attribution d'install + le routage vers le bon store selon l'appareil.
// Surchargeable via REACT_APP_ONELINK_URL.
const ONELINK_URL = process.env.REACT_APP_ONELINK_URL || 'https://ouigoo.onelink.me/kN5C';

// Construit l'URL OneLink en traduisant les UTM en paramètres AppsFlyer.
// Mapping : utm_source -> pid, utm_medium -> af_channel, utm_campaign -> c, utm_content -> af_ad.
// Laisse aussi passer d'éventuels paramètres AppsFlyer déjà présents (pid, c, af_*, deep_link_value).
function buildOneLink(search) {
  const incoming = new URLSearchParams(search);
  let url;
  try {
    url = new URL(ONELINK_URL);
  } catch (_) {
    return ONELINK_URL;
  }
  const set = (key, value) => {
    if (value) url.searchParams.set(key, value);
  };

  set('pid', incoming.get('utm_source') || 'website');
  set('af_channel', incoming.get('utm_medium'));
  set('c', incoming.get('utm_campaign'));
  set('af_ad', incoming.get('utm_content'));

  incoming.forEach((value, key) => {
    if (value && (key === 'pid' || key === 'c' || key === 'deep_link_value' || key.startsWith('af_'))) {
      url.searchParams.set(key, value);
    }
  });

  return url.toString();
}

export default function StoreRedirect() {
  const { store } = useParams();
  const location = useLocation();

  useEffect(() => {
    initMetaPixel();
    trackPageView();

    if (store !== 'play-store' && store !== 'app-store') {
      window.location.replace('/ouigoo-app');
      return;
    }

    const utm = Object.fromEntries(new URLSearchParams(location.search));
    if (store === 'play-store') {
      trackPlayStoreClick(utm);
    } else {
      trackAppStoreClick(utm);
    }

    const targetUrl = buildOneLink(location.search);
    const timer = window.setTimeout(() => {
      window.location.replace(targetUrl);
    }, 800);

    return () => window.clearTimeout(timer);
  }, [store, location.search]);

  return (
    <div className="min-h-screen bg-gray-50 px-4 py-16 text-center text-gray-700">
      <p className="text-base font-medium">Redirection vers le store...</p>
    </div>
  );
}
